const BanFormatter = ({ reason, contractNumber }) => ({
  banReason: reason,
  bannedContract: contractNumber,
});

export default BanFormatter;
